import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, ButtonLink, IconNewWindow } from "braid-design-system";
import { translations } from "../../../../components/.vocab/index.mjs";
import { applyButton } from "../../JobDetailsView/JobDetailsView.css.mjs";
import { useMelwaysLink } from "@seek/melways-react";
const isValidAbsoluteUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch (_) {
    return false;
  }
};
const checkIfContainLangPrefix = (str) => {
  const regex = /^\/(th|id)\//;
  return regex.test(str);
};
const useApplyUrl = ({
  path,
  renderRelativePaths
}) => {
  const _path = checkIfContainLangPrefix(path) ? path.substring(3) : path;
  const melwaysLink = useMelwaysLink({
    path: _path,
    product: "candidate",
    absolute: !renderRelativePaths
  });
  if (isValidAbsoluteUrl(path)) {
    return path;
  }
  return melwaysLink;
};
const noop = () => {
};
const ApplyButton = ({
  job,
  ctas,
  shouldOpenApplyInNewTab,
  size = "standard",
  renderRelativePaths = false
}) => {
  const { t } = useTranslations(translations);
  const applyUrl = useApplyUrl({ path: job.applyUrl, renderRelativePaths });
  return /* @__PURE__ */ jsx(Box, { className: applyButton, width: "full", children: /* @__PURE__ */ jsx(
    ButtonLink,
    {
      href: applyUrl,
      onClick: (ctas == null ? void 0 : ctas.onApplyClick) ?? noop,
      tone: "brandAccent",
      target: job.isLinkOut || shouldOpenApplyInNewTab ? "_blank" : "",
      icon: job.isLinkOut ? /* @__PURE__ */ jsx(IconNewWindow, { alignY: "lowercase" }) : void 0,
      iconPosition: "trailing",
      "data-automation": "job-detail-apply",
      "aria-label": t("Apply for {jobTitle} at {jobCompanyName}", {
        jobTitle: job.title,
        jobCompanyName: job.company.name
      }),
      size,
      children: job.isLinkOut ? t("Apply") : t("Quick apply")
    }
  ) });
};
export {
  ApplyButton
};
